import { URLSearchParams } from 'url';
import { StateCreator } from 'zustand';

import { config } from '../../config';
import { ParameterState } from './types/ParameterState';

export const keysToPersist = [
  'amount',
  'applicationUpdateMessage',
  'apr',
  'authType',
  'autopayNumber',
  'coApplicantCollectAgreeToTerms',
  'collectAgreeToTerms',
  'error',
  'firstName',
  'hasDuplicateApplication',
  'leadChannelCode',
  'migrateUser',
  'monthlyPaymentAmount',
  'phoneNumber',
  'term',
  'token',
  'vehicleId',
];

export const parameterStore: StateCreator<ParameterState> = (set, get) => ({
  amount: null,
  applicationUpdateMessage: null,
  apr: null,
  authType: null,
  autopayNumber: null,
  coApplicantCollectAgreeToTerms: null,
  collectAgreeToTerms: null,
  error: null,
  firstName: null,
  hasDuplicateApplication: null,
  intent: null,
  leadChannelCode: null,
  migrateUser: null,
  monthlyPaymentAmount: null,
  phoneNumber: null,
  term: null,
  token: null,
  vehicleId: null,

  clearHasDuplicateApplication(): void {
    set({ hasDuplicateApplication: null });
  },
  setFromURLSearchParams(searchParams?: URLSearchParams): void {
    if (!searchParams) {
      return;
    }

    Object.keys(get())
      .filter((stateKey: string) => searchParams.has(stateKey))
      .forEach((stateKey: string) => {
        set({ [stateKey]: searchParams.get(stateKey) });
      });
  },
  toggleLeadChannelCode(enableOriginChannelAttribution?: boolean): void {
    // explicitly check for false to allow undefined to mean "do nothing"
    if (enableOriginChannelAttribution === false) {
      set({ leadChannelCode: config.defaultLeadChannelCodeForCancelledApps });
    }
  },
});
